import React from "react";
import styled from "styled-components";
import { Button, Chip, Tooltip, Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { DateAndTimeGridCell } from "../common/DateAndTimeGridCell";
import { isFeatureEnabled } from "../../services/customerConfig";

const ActiveText = styled.span`
  color: #43a047;
`;

const InactiveText = styled.span`
  color: #c1c1c1;
`;

const getColumnsData = () => {
  // Column props reference available at - ota-portal_v2\node_modules\.pnpm\@mui+x-data-grid@5.15.2_rrttaqilrsb3aifveu7wjrwxnm\node_modules\@mui\x-data-grid\models\colDef\gridColDef.d.ts
  const columns = [
    {
      field: "serialNo",
      headerName: "Serial No",
      minWidth: 250,
      renderCell: (data) => {
        const { row: { serialNo = "" } = {} } = data;
        return (
          <Tooltip title={data?.value}>
            <Button
              size="medium"
              sx={{ justifyContent: "flex-start", textTransform: "none" }}
              component={RouterLink}
              to={`/vehicles/${serialNo}`}
            >
              {data?.value}
            </Button>
          </Tooltip>
        );
      },
    },
    {
      field: "active",
      headerName: "Status",
      type: "boolean",
      minWidth: 100,
      renderCell: ({ row }) =>
        row.active ? (
          <ActiveText>Active</ActiveText>
        ) : (
          <InactiveText>Inactive</InactiveText>
        ),
    },
    {
      field: "certAvailable",
      headerName: "Certificate",
      type: "boolean",
      minWidth: 100,
      renderCell: ({ row }) =>
        row.certAvailable ? (
          <ActiveText>Available</ActiveText>
        ) : (
          <InactiveText>Not Available</InactiveText>
        ),
    },
    {
      field: "vehicleKey",
      headerName: "Vehicle Key",
      minWidth: 500,
      renderCell: (data) => (
        <Tooltip title={data?.value}>
          <p
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {data?.value}
          </p>
        </Tooltip>
      ),
    },
  ];

  // Conditionally add HU Manufactured column
  if (isFeatureEnabled("showHUManufactured")) {
    columns.push({
      field: "serialNoCreatedAt",
      headerName: "HU Manufactured",
      minWidth: 150,
      type: "dateTime",
      valueGetter: (value) => value ? new Date(value) : null,
      renderCell: (data) => (
        <DateAndTimeGridCell value={data?.row?.serialNoCreatedAt} />
      ),
    });
  }

  // Conditionally add Vehicle Manufactured column
  if (isFeatureEnabled("showVehicleManufactured")) {
    columns.push({
      field: "vehicleKeyUpdatedAt",
      headerName: "Vehicle Manufactured",
      minWidth: 250,
      editable: false,
      type: "dateTime",
      valueGetter: (value) => value ? new Date(value) : null,
      renderCell: (data) => (
        <DateAndTimeGridCell value={data?.row?.vehicleKeyUpdatedAt} />
      ),
    });
  }

  // Conditionally add Purchase Date column
  if (isFeatureEnabled("showVehiclePurchaseDate")) {
    columns.push({
      field: "vehicle.vehiclePurchaseDetails.purchaseDate",
      headerName: "Purchased",
      editable: false,
      minWidth: 250,
      type: "dateTime",
      valueGetter: (value) => value ? new Date(value) : null,
      renderCell: (data) => (
        <DateAndTimeGridCell
          value={data?.row?.vehicle?.vehiclePurchaseDetails?.purchaseDate || ""}
        />
      ),
    });
  }

  return columns;
};

export { getColumnsData };
